import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AppComponent }   from './app.component';
import { SidebarModule } from './sidebar/sidebar.module';
import { FixedPluginModule } from './shared/fixedplugin/fixedplugin.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule} from './shared/navbar/navbar.module';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AppRoutes } from './app.routing';
import { APIS } from './services/api';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgbAlertModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmDialogModule } from "./confirm-dialog.module";
import { SignaturePadModule } from 'angular2-signaturepad'; 
import { MainPipe } from './main-pipe.module';
import {  MomentDateFormatter } from './customDateParserFormatter';
import { PageNotFoundComponent } from './pagenotfound.component';
import { APP_BASE_HREF } from '@angular/common';
import { environment } from '../environments/environment';

@NgModule({
    imports:      [
        BrowserAnimationsModule, NgbAlertModule, ToastrModule.forRoot({
            timeOut: 10000,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
        }),      
        FormsModule, NgxSpinnerModule, SignaturePadModule, MainPipe,
        RouterModule.forRoot(AppRoutes,{
          useHash: false
        }),
        SidebarModule,
        NavbarModule,
        FooterModule,
        FixedPluginModule,
        HttpClientModule, ConfirmDialogModule
   
        
    ],
    declarations: [
        AppComponent,
        AdminLayoutComponent,
        AuthLayoutComponent,
        DashboardComponent,
        PageNotFoundComponent
    ],
    //exports: [
    //    PhoneMaskDirective
    //],
    bootstrap: [AppComponent],
    providers: [{ provide: NgbDateParserFormatter, useClass: MomentDateFormatter }, APIS],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule { }
